import {
  call,
  put,
  throttle
} from "redux-saga/effects";
import {
  authorizedRequest
} from "utils/api";
import {
  API_SEARCH
} from "constants/apiRoutes";
import {
  ToastSuccess,
  ToastError
} from "components/Global/Toasts/Toasty";

export const SEARCH_QUERY_FETCH = "SEARCH_QUERY_FETCH";
export const SEARCH_QUERY_SUCCESS = "SEARCH_QUERY_SUCCESS";
export const SEARCH_QUERY_FAILURE = "SEARCH_QUERY_FAILURE";
export const SEARCH_QUERY_RESET = "SEARCH_QUERY_RESET";

const initialState = {
  funds: [],
  deals: [],
  loans: [],
  quotes: []
};

export default function searchReducer(state = initialState, action) {
  const {
    type,
    payload
  } = action;
  switch (type) {
    case SEARCH_QUERY_SUCCESS:
      return {
        ...state,
        funds: payload.funds,
        loans: payload.loans,
        quotes: payload.quotes,
        deals: payload.deals
      };
    case SEARCH_QUERY_RESET:
      return initialState;
    default:
      return state;
  }
}

export function searchFetch(payload) {
  return {
    type: SEARCH_QUERY_FETCH,
    payload
  };
}

export function searchReset() {
  return {
    type: SEARCH_QUERY_RESET
  };
}

export function searchFetchSuccess(payload) {
  return {
    type: SEARCH_QUERY_SUCCESS,
    payload
  };
}

function searchFetchFailure(payload) {
  return {
    type: SEARCH_QUERY_FAILURE,
    payload
  };
}

// Saga
function* fetchSaga(action) {
  const {
    payload
  } = action;
  try {
    const response = yield call(
      authorizedRequest,
      `/search/?name=${payload}`
    );
    yield put(searchFetchSuccess(response));
  } catch (error) {
    yield put(searchFetchFailure(error));
    ToastError(error.message);
  }
}

export function* searchSaga() {
  yield throttle(500, SEARCH_QUERY_FETCH, fetchSaga);
}
